export default __webpack_public_path__ + "static/media/TruckStop.29b442db.jpg";